import { ParsedUrlQuery } from 'querystring';

const DEEP_LINK_PACKAGE_NAME = 'com-eventbrite-attendee';
const QUERY_PARMS_TO_FILTER = ['overridelistingsorigin', 'skip_redirection', 'forcenocache'];

export const getBaseDeepLinkAppUrl = (eventId: string, query: ParsedUrlQuery) => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query).filter(([key]) => !QUERY_PARMS_TO_FILTER.includes(key))) {
    params.append(key, value as string);
  }
  const parameters = params.toString() ? `&${params.toString()}` : '';

  return (referrer: string) => `${DEEP_LINK_PACKAGE_NAME}://event/${eventId}/?referrer=${referrer}${parameters}`;
};
